import React from "react";
import styles from "./Input.module.css";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ label, id, className = "", ...props }, ref) => {
        const inputId = id || label.replace(/\s+/g, "-").toLowerCase();

        return (
            <div className={`${styles.inputWrapper} ${className}`}>
                <input
                    ref={ref}
                    id={inputId}
                    className={styles.input}
                    placeholder=" "
                    {...props}
                />
                <label htmlFor={inputId} className={styles.label}>
                    {label}
                </label>
            </div>
        );
    }
);

Input.displayName = "Input";
